// extracted by mini-css-extract-plugin
module.exports = {"NotFoundContainer":"styles_NotFoundContainer__2TO2Q","scale":"styles_scale__1nFl7","float":"styles_float__31hRY"};